import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { extractServerErrorMessage } from "../utils/errorHandler";
export var useServerErrorMessage = function (error, fallbackId) {
    var formatMessage = useIntl().formatMessage;
    var _a = useState(null), message = _a[0], setMessage = _a[1];
    useEffect(function () {
        if (!error) {
            setMessage(null);
            return undefined;
        }
        var cancelled = false;
        extractServerErrorMessage(error, formatMessage, formatMessage({ id: fallbackId })).then(function (text) {
            if (!cancelled)
                setMessage(text);
        });
        return function () {
            cancelled = true;
        };
    }, [error, fallbackId, formatMessage]);
    return message;
};
